import { eEstadoFichaSso } from "../common/enumModel";
import { IFichaSsoModel } from "../interfaces/ficha-sso/IFichaSsoModel";
import { ResumenAccidentabilidadModel } from "./ResumenAccidentabilidadModel";

export class FichaSsoModel implements IFichaSsoModel{
    idFichaSso: number;
    anio: number;
    mes: number;
    nombreMes: string
    idContratista?: number;
    contratista?: string
    idSede : number;
    sede : string
    fechaLimite : Date;
    fechaAmpliada?: Date;
    cantidadPersonal?: number; 
    cantidadHoras?: number;
    accidentesLeves?: number;
    accidentesIncapacitantes?: number;
    accidentesFatales?: number;
    diasPerdidos?: number;
    primerosAuxilios?: number;
    incidentesConDanio?: number;
    incidentesSinDanio?: number;
    incidentesConPotencial?: number;
    incidentesPeligrosos?: number;
    atencionesMedicas?: number;
    actosInseguros?: number;
    condicionesInseguras?: number;
    charlasSemanales?: number;
    charlas5Minutos?: number;
    horasCapacitacion?: number;
    horasEntrenamiento? : number;
    cantidadPT? : number;
    cantidadATS? : number;
    cantidadPTAR? : number;
    cantidadAuditorias? : number;
    cantidadSimulacros? : number;
    cantidadCaminatas?: number;
    cantidadSafetyMoments?: number;
    cantidadHipos?: number;
    avancePasst?: number;
    idEstado: eEstadoFichaSso;
    estado: string;
    fechaModificacion?: Date;
    huboAccidentes: boolean;
    editable: boolean;
    puedeAmpliar: boolean;
    accidentes: Array<ResumenAccidentabilidadModel>;
    esEngie: boolean;
    nombreArchivo: string;
    rutaArchivo:string;
    idCompania:number;
    compania:string;

    constructor(){
        this.idFichaSso = 0;
        this.anio = 0;
        this.mes = 0;
        this.nombreMes = '';
        this.idSede =0;
        this.sede = '';
        this.fechaLimite = new Date();
        this.idEstado = eEstadoFichaSso.Pendiente;
        this.estado = 'Pendiente';
        this.editable = false;
        this.puedeAmpliar = false;
        this.huboAccidentes = false;
        this.esEngie = false;
        this.accidentes = new Array<ResumenAccidentabilidadModel>();
        this.nombreArchivo = '';
        this.rutaArchivo = '';
        this.idCompania = 0;
        this.compania = '';
    }
}